import React from "react";
import { HeaderProps } from "react-table";
import { $enum } from "ts-enum-util";
import styled from "styled-components";

import { Text } from "src/components/shared/text";
import { ItemInsuranceProviderEnum } from "src/utils/api";
import { Select } from "../forms/Select";
import { mapItemInsuranceProvider } from "src/utils/item";

export function SelectItemInsuranceColumnFilter<T extends Record<string, unknown>>({ 
  column: {
    filterValue, setFilter, id 
  }, onChange
}: HeaderProps<T> & {
  onChange: () => void;
}): React.ReactElement {
  const options: {
    label: string;
    value: ItemInsuranceProviderEnum | undefined;
}[] = ($enum(ItemInsuranceProviderEnum).getKeys()).reduce((
  acc: Array<{label: string; value: ItemInsuranceProviderEnum}>, key, index
) => {
  return acc.concat([
    {
      label: mapItemInsuranceProvider($enum(ItemInsuranceProviderEnum).getValues()[index]),
      value: $enum(ItemInsuranceProviderEnum).getValues()[index]
    }
  ]);
}, []);

  const defaultOption = {
    value: undefined,
    label: "All providers" 
  };

  options.unshift(defaultOption);

  return (
    <Select
      value={filterValue ? options.find(option => option.value === filterValue) : defaultOption}
      name={id}
      placeholder="Select insurance provider"
      onChange={({ value }) => {
        setFilter(value ? value.value : undefined);

        if (onChange) {
          onChange();
        }
      }}
      options={options}
      labelKey="label"
      valueKey="value"
      // eslint-disable-next-line react/no-children-prop
      children={(option=> <StyledOption>{option.label}</StyledOption>)}
    />
  );
}

const StyledOption = styled(Text)`
  width: 100%;
  padding: 1rem;
  display: block;
`;
